import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class EntityContact extends HasProjectMixin(Model) {
  static get $name() {
    return "EntityContactRelation";
  }

  static get fields() {
    return [
      { name: "contactId", dataSource: "contact" },
      { name: "archived", dataSource: "archived" },
      { name: "order", dataSource: "order" },
    ];
  }

  // bryntum doesn't call custom field setter functions when the field is set through nested field in column editor
  // see issue link => https://github.com/bryntum/support/issues/8877
  set(field, value) {
    if (typeof field === "string" && field?.includes("contactRecord.")) {
      const [parent, child] = field.split(".");
      this[parent][child] = value;
    }

    // this.contactRecord may be null when deleting a record
    if (this.contactRecord) {
      this.contactRecord.updateRendererCount++;
    }
    super.set(...arguments);
  }
}

EntityContact.exposeProperties();
